/*
 * @Descripttion: 订单催评部分效果详情
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React, {useEffect, useState, useImperativeHandle, forwardRef} from 'react';
import {Table} from '@alifd/next';
import { Servlets } from '@/service';
import utils from '@/common/utils';
import { Button } from '@alifd/next';
import LzMsg from '@/components/common/LzMsg';
import LzPagination from '@/components/common/LzPagination';
import DataBox from '../dataBox';
import styles from './index.module.scss';
import moment from 'moment';

const ddcpSummary = ({form}, ref) => {
  const { startTime = '', endTime = '', taskId = '' } = form;
  const [tableLoading1, setTableLoading1] = useState(false);
  const [data1, setData1] = useState<any>({
    careNum: 0,
    commentNum: 0,
    reportDate: 0,
    successRate: 0
  });
  const [table1, setTable1] = useState<any>([]);
  const [pageInfo1, setPageInfo1] = useState<any>({
    pageNo: 1,
    pageSize: 5,
    total: 0,
  });

  const getSummaryOne = async () => {
    Servlets('getOrderCareCPSummaryOne', {
      taskType: 'S_DDCP',
      startTime: startTime ? moment(startTime).startOf('day').valueOf() : '',
      endTime: endTime ? moment(endTime).endOf('day').valueOf() : '',
      taskId,
    }).then(res => {
      if (res.success) {
        setData1({ ...data1, ...res.data });
      } else {
        LzMsg.error(res.resp_msg);
      }
    })
  };

  const getTableOne = async (v) => {
    setTableLoading1(true);
    Servlets('getOrderCareCPTableOne', {
      taskType: 'S_DDCP',
      preSaleType: 2,
      startTime: startTime ? moment(startTime).startOf('day').valueOf() : '',
      endTime: endTime ? moment(endTime).endOf('day').valueOf() : '',
      taskId,
      pageNo: pageInfo1.pageNo,
      pageSize: pageInfo1.pageSize,
      ...v
    }).then(res => {
      if (res.success) {
        setTable1([ ...res.data ]);
        setPageInfo1({ ...res.page });
        setTableLoading1(false);
      } else {
        LzMsg.error(res.resp_msg);
        setTableLoading1(false);
      }
    })
  };

  const handlePageSizeChange1 = async (pages: object = {}) => {
    try {
      await getTableOne({ pageNo: pages.pageNo, pageSize: pages.pageSize });
    } catch (e) {
      // LzMsg.error(e.message);
      console.log(e)
    }
  };

  const searchAll = async () => {
    await getSummaryOne();
    await getTableOne({pageNo: 1, pageSize: pageInfo1.pageSize});
  };

  const exportExl = () => {
    if(table1.length > 0) {
      Servlets('exportOrderCareCPSummaryDetail', {
        taskType: 'S_DDCP',
        startTime: startTime ? moment(startTime).startOf('day').valueOf() : '',
        endTime: endTime ? moment(endTime).endOf('day').valueOf() : '',
        taskId,
      }).then((res) => {
        utils.downloadFile(res);
      })
    } else {
      LzMsg.error('数据为空，请切换查询条件后重试');
    }
  };

  useEffect(() => {
    searchAll();
  }, []);

  useImperativeHandle(ref, () => ({
    interfaceSearch: () => {searchAll()},
  }));

  return <div className={styles['ddcf-summary']}>
      <div className={styles.btn}>
        <Button type='primary' onClick={() => exportExl()}>导出明细数据</Button>
      </div>
      <div className={styles['border-box']}>
        <div className={styles.title}>统计时间内的所有催评效果数据</div>
        <div className={styles['panel-summary']}>
          <DataBox title="已催评的订单总数 / 笔" value={data1.careNum} />
          <DataBox title="完成评价的订单数 / 笔" value={data1.commentNum} />
          <DataBox title="催付成功率" value={data1.successRate} />
        </div>
        <div style={{marginTop: 20}}>
          <div className={styles.title}>统计时间内的每日效果数据</div>
          <Table loading={tableLoading1} dataSource={table1}>
            <Table.Column title="日期" dataIndex="reportDate" />
            <Table.Column title="已催评订单数/笔" dataIndex="careNum" />
            <Table.Column title="完成评价订单数/笔" dataIndex="commentNum" />
            <Table.Column title="催评成功率" dataIndex="successRate" />
          </Table>
          <LzPagination pageInfo={pageInfo1} onChange={handlePageSizeChange1} />
        </div>
      </div>

  </div>
};

export default forwardRef(ddcpSummary);
